
import React from 'react';
import StructuredData from '@/components/StructuredData';
import { Site } from '@/services/types';

interface CollectionPageSEOSchemaProps {
  sites: Site[];
  isDeptPage: boolean;
  deptName?: string;
  deptCode?: string;
}

const CollectionPageSEOSchema: React.FC<CollectionPageSEOSchemaProps> = ({ 
  sites, 
  isDeptPage, 
  deptName, 
  deptCode 
}) => {
  // Schéma de collection pour la page départementale
  const collectionSchema = isDeptPage && deptCode ? {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id": `https://www.groupefabre-environnement.fr/sites?dept=${deptCode}#collectionpage`,
    "name": `Nos sites dans ${deptName} (${deptCode})`,
    "description": `Découvrez tous nos centres de recyclage et gestion des déchets dans le département ${deptName}`,
    "url": `https://www.groupefabre-environnement.fr/sites?dept=${deptCode}`,
    "mainEntity": {
      "@type": "ItemList",
      "numberOfItems": sites.length,
      "itemListElement": sites.map((site, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "LocalBusiness",
          "@id": `https://www.groupefabre-environnement.fr/sites/${site.id}#localbusiness`,
          "name": site.name,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": site.city,
            "postalCode": site.postalCode
          }
        }
      }))
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Accueil",
          "item": "https://www.groupefabre-environnement.fr/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Nos sites",
          "item": "https://www.groupefabre-environnement.fr/sites"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": `Sites ${deptName}`,
          "item": `https://www.groupefabre-environnement.fr/sites?dept=${deptCode}`
        }
      ]
    }
  } : undefined;

  if (!collectionSchema) return null;

  return <StructuredData data={collectionSchema} />;
};

export default CollectionPageSEOSchema;
